// extracted by mini-css-extract-plugin
export default {"sticky-action-banner__spacer":"StickyActionBanner_sticky-action-banner__spacer__As0Zo","sticky-action-banner__banner":"StickyActionBanner_sticky-action-banner__banner__bYLDP"};